(() => {
  function bindBstHoverReveal(carouselRoot, track, n) {
    const hoverViewport = carouselRoot.querySelector('.bestsellers-card__viewport[data-bst-hover-reveal="true"]');
    if (!hoverViewport || !track || n < 2) {
      return;
    }
    const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!fineHover.matches || reduceMotion.matches) {
      return;
    }
    let i = 0;
    const applyStrip = (nextIndex) => {
      i = ((nextIndex % n) + n) % n;
      track.style.setProperty('--bst-i', String(i));
    };
    applyStrip(0);
    let hoverStartIndex = 0;
    hoverViewport.addEventListener('mouseenter', () => {
      if (i !== 0) {
        return;
      }
      hoverStartIndex = 0;
      applyStrip(1);
    });
    hoverViewport.addEventListener('mouseleave', () => {
      if (i === 1) {
        applyStrip(hoverStartIndex);
      }
    });
  }

  function initBestsellerCarousels(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[data-bst-carousel]').forEach((carouselRoot) => {
      const enableSlider = carouselRoot.getAttribute('data-enable-slider') === 'true';
      const count = parseInt(carouselRoot.getAttribute('data-images') || '0', 10) || 0;
      const track = carouselRoot.querySelector('[data-bst-slides]');
      if (!track) {
        return;
      }

      if (enableSlider) {
        if (count < 2) {
          return;
        }
        const dots = carouselRoot.querySelectorAll('[data-bst-dot]');
        const prev = carouselRoot.querySelector('[data-bst-prev]');
        const next = carouselRoot.querySelector('[data-bst-next]');
        const n = count;
        let i = 0;
        if (n > 0) {
          track.style.setProperty('--bst-n', String(n));
        }
        const apply = (nextIndex) => {
          i = ((nextIndex % n) + n) % n;
          track.style.setProperty('--bst-i', String(i));
          dots.forEach((d, j) => {
            d.classList.toggle('is-active', j === i);
          });
        };

        if (prev) {
          prev.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            apply(i - 1);
          });
        }
        if (next) {
          next.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            apply(i + 1);
          });
        }
        dots.forEach((d, j) => {
          d.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            apply(j);
          });
        });

        if (n >= 2) {
          let startX = 0;
          const threshold = 40;
          const onStart = (e) => {
            if (!e.touches || !e.touches[0]) {
              return;
            }
            startX = e.touches[0].clientX;
          };
          const onEnd = (e) => {
            if (!e.changedTouches || !e.changedTouches[0]) {
              return;
            }
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) < threshold) {
              return;
            }
            e.preventDefault();
            if (dx < 0) {
              apply(i + 1);
            } else {
              apply(i - 1);
            }
          };
          const viewport = carouselRoot.querySelector('.bestsellers-card__viewport');
          if (viewport) {
            viewport.addEventListener('touchstart', onStart, { passive: true });
            viewport.addEventListener('touchend', onEnd, { passive: false });
          }
        }

        bindBstHoverReveal(carouselRoot, track, n);
        return;
      }

      if (count >= 2) {
        bindBstHoverReveal(carouselRoot, track, count);
      }
    });
  }

  function initBestsellersSection(section) {
    const viewAll = section.querySelector('[data-bst-viewall]');

    const setActiveTab = (id) => {
      section.querySelectorAll('[data-bst-tab]').forEach((tab) => {
        const isMatch = tab.getAttribute('data-bst-tab') === id;
        tab.classList.toggle('is-active', isMatch);
        tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });
      section.querySelectorAll('[data-bst-panel]').forEach((panel) => {
        const isMatch = panel.getAttribute('data-bst-panel') === id;
        panel.toggleAttribute('hidden', !isMatch);
        panel.classList.toggle('is-active', isMatch);
        if (isMatch && viewAll) {
          const url = panel.getAttribute('data-bst-collection-url') || viewAll.getAttribute('href');
          if (url && url !== '#') {
            viewAll.setAttribute('href', url);
          }
        }
      });
    };

    section.querySelectorAll('[data-bst-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-bst-tab');
        if (id) {
          setActiveTab(id);
        }
      });
    });

    initBestsellerCarousels(section);
  }

  document.querySelectorAll('[data-bestsellers-section]').forEach((section) => {
    initBestsellersSection(section);
  });

  window.initBestsellerCarousels = initBestsellerCarousels;
})();
